<div class="mt-3">
  <as-field-editor
    label="{{ 'task_detail.description' | translate }}"
    [control]="control"
    [disabled]="!!task.dates?.validationDate"
    [readonly]="!!task.dates?.validationDate"
    placeholder="{{ 'add_task.task_description_placeholder' | translate }}">
  </as-field-editor>
</div>
